




















































import { Component, Vue, Watch } from 'vue-property-decorator'
import { DialogEntry, GetterDialog, MutationDialog } from '../../store/dialog'
import errorHandler from '../../errorHandler'

@Component
export default class Dialog extends Vue {
  @MutationDialog
  setDialogEntry: (entry: DialogEntry) => void

  @GetterDialog
  currentDialogEntry: DialogEntry | DialogEntry

  dialogDisplayed: boolean = false
  waiting: boolean = false

  @Watch('currentDialogEntry')
  onDialogEntryChange (entry?: DialogEntry | null) {
    this.dialogDisplayed = !!entry
  }

  async onOk () {
    try {
      this.waiting = true
      if (this.currentDialogEntry.onOk) {
        this.currentDialogEntry.onOk()
      }
    } catch (err) {
      errorHandler(err)
    } finally {
      this.waiting = false
      this.dialogDisplayed = false
    }
  }

  onCancel () {
    if (this.currentDialogEntry.onCancel) {
      this.currentDialogEntry.onCancel()
    }
    this.dialogDisplayed = false
  }
}
